<template>
  <v-flex xs12 px-2>
    <v-layout row align-center justify-center mb-2 v-if="err || successMessage">
      <v-flex xs12 px-3 v-if="err">
        <v-alert :value="true" type="error">{{err}}</v-alert>
      </v-flex>
      <v-flex xs12 px-3 v-if="successMessage">
        <v-alert :value="true" type="success" >{{successMessage}}</v-alert>
      </v-flex>
    </v-layout>
    <v-tabs
        v-model="active"
        color=""
        dark
        slider-color="primary"
    >
      <v-tab
          v-for="(item, index) in menu"
          :key="index"
          :to="{ name: item.to.name }"
      >
        {{item.title}}
      </v-tab>
    </v-tabs>
      <router-view
          style="display: block !important;"
          @error="err = $event"
          @success="successMessage = $event"
      />
  </v-flex>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Orders',
  data() {
    return {
      active: null,
      menu: [
        {
          title: this.$lang.labels.ordersSearch,
          to: {
            name: 'ordersSearch',
          },
        },
        {
          title: this.$lang.labels.blacklist,
          to: {
            name: 'blacklist',
          },
        },
      ],
      err: '',
      successMessage: '',
      loading: false,
      isInit: false,
      snackbarTime: 6000,
      snackbar: false,
      snackbarType: 'success',
      message: '',
    };
  },
  watch: {
  },
  computed: {
    ...mapGetters({
      company: 'company',
      companyActive: 'companyActive',
    }),
  },
  methods: {
  },
  created() {
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/OrdersAdmin/Orders.vue